import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { fetcher } from '../../../services/api';
import { InputWrapper } from '../../common/input-wrapper';
import { emailValidation, required } from '../../../utils/validations';
import { useModalClose } from '../../../utils/useModalClose';
import { ModalProps } from '../../../services/modals.service';
import { ItemEmailCampaign } from './EmailCampaignTab';
import { trpcSwr } from '../../../api/trpc';

import { AlertService } from '../../../services/alert.service';
import { useNavigate } from 'react-router-dom';

interface SendExampleModalProps extends ModalProps {
  emailCampaign?: ItemEmailCampaign;
}

export const SendExampleModal: React.FC<SendExampleModalProps> = ({
  close,
  emailCampaign,
  reject,
}) => {
  const navigate = useNavigate();

  const { handleSubmit, control } = useForm<{ id: number; email: string }>({
    defaultValues: emailCampaign
      ? {
          id: emailCampaign.id,
          email: '',
        }
      : {},
  });

  const { trigger: triggerCreate } =
    trpcSwr.emailCampaign.sendExample.useSWRMutation({
      fetcher,
    });
  const onSubmit = handleSubmit(async (form) => {
    if (emailCampaign?.id) {
      await triggerCreate({
        id: emailCampaign.id,
        email: form.email,
      });
    }
    AlertService.success();
    close();
    navigate('/marketing/email');
  });

  const modalRef = useModalClose(reject);

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button
            type="button"
            className="btn-close"
            onClick={() => reject()}
          />
        </div>
        <div className="text-center">
          <i className="bi bi-envelope fs-1"></i>
        </div>

        <form className="modal-body pb-4 px-4" onSubmit={onSubmit}>
          <div className="text-center mb-4 mx-auto">
            <h3>Отправить тестовое письмо</h3>
          </div>
          <Controller
            control={control}
            name="email"
            rules={{
              ...required,
              ...emailValidation,
            }}
            render={({ field, fieldState }) => (
              <InputWrapper
                className="mb-3"
                title={'Кому'}
                error={fieldState.error?.message}
              >
                <input type="text" className="form-control" {...field} />
              </InputWrapper>
            )}
          />

          <button className="btn btn-success w-100">Отправить</button>
        </form>
      </div>
    </div>
  );
};
